<!--New Add Dependent Modal-->
<div
  #dependentModal
  id="add_dependent_modal_form"
  class="modal fade custom-modal"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form
        [formGroup]="dependentForm"
        (ngSubmit)="onSubmitDependent()"
        action="#"
        enctype="multipart/form-data"
        autocomplete="off"
        method="post"
      >
        <div class="modal-header">
          <h5 class="modal-title">Add New Members</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="closePopup('dependent')"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label for="gender" class="control-label mb-10"
              >Gender<span class="text-danger">*</span>
            </label>
            <select
              formControlName="gender"
              class="form-select form-control"
              name="gender"
            >
              <option value="" disabled>Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            <div
              class="text-danger mt-1"
              *ngIf="
                dependentForm.get('gender')?.touched &&
                dependentForm.get('gender')?.errors?.required
              "
            >
              Gender is required.
            </div>
          </div>
          <div class="mb-3">
            <label for="name" class="control-label mb-10">
              First Name <span class="text-danger">*</span></label
            >
            <input
              (keydown)="cleanInput($event)"
              placeholder="Enter First Name"
              type="text"
              formControlName="first_name"
              name="first_name"
              class="form-control"
            />
            <div
              class="text-danger mt-1"
              *ngIf="
                dependentForm.get('first_name')?.touched &&
                dependentForm.get('first_name')?.errors?.required
              "
            >
              First Name is required.
            </div>
          </div>
          <div class="mb-3">
            <label for="name" class="control-label mb-10">
              Last Name <span class="text-danger">*</span></label
            >
            <input
              (keydown)="cleanInput($event)"
              placeholder="Enter Last Name"
              type="text"
              formControlName="last_name"
              name="last_name"
              class="form-control"
            />
            <div
              class="text-danger mt-1"
              *ngIf="
                dependentForm.get('last_name')?.touched &&
                dependentForm.get('last_name')?.errors?.required
              "
            >
              Last Name is required.
            </div>
          </div>
          <div class="mb-3">
            <label for="dob" class="control-label mb-10"
              >Date of Birth <span class="text-danger">*</span></label
            >

            <div class="position-relative">
              <input
                #adddp="bsDatepicker"
                type="text"
                class="form-control"
                bsDatepicker
                placement="top"
                placeholder="Select Date of Birth"
                formControlName="dob"
                (bsValueChange)="handleDateOfBirthSelection($event)"
                [bsConfig]="dobsDatepickerConfig"
                [outsideClick]="true"
                inputmode="none"
                readonly
                onkeydown="return false;"
                autocomplete="new-dob"
              />
              <i
                class="fa-regular fa-calendar position-absolute"
                (click)="adddp.toggle()"
              ></i>
            </div>

            <div *ngIf="dependentForm.get('dob')?.touched">
              <div
                class="text-danger mt-1"
                *ngIf="dependentForm.get('dob')?.errors?.required"
              >
                Date of Birth is required.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="dependentForm.errors?.futureDate"
              >
                Date of Birth cannot be in the future.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="dependentForm.errors?.ageExceeded"
              >
                Age cannot be more than 65.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="dependentForm.errors?.under18NotAllowed"
              >
                Member must be 18+ to add a mobile number.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="dependentForm.errors?.zeroAgeNotAllowed"
              >
                Age must be greater than 0.
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="relation" class="control-label mb-10"
              >Relationship <span class="text-danger">*</span></label
            >
            <select class="form-select form-control" formControlName="relation">
              <option value="" disabled>Select Relationship</option>
              <option value="Spouse">Spouse</option>
              <option value="Biological children">Biological children</option>
              <option value="Sibling">Sibling</option>
              <option value="Biological parent">Biological parent</option>
              <option value="Grandparent">Grandparent</option>
              <option value="In laws">In laws</option>
            </select>
            <div
              class="text-danger mt-1"
              *ngIf="
                dependentForm.get('relation')?.touched &&
                dependentForm.get('relation')?.errors?.required
              "
            >
              Relationship is required.
            </div>
          </div>

          <div class="mb-3">
            <label class="control-label mb-2"> Member's Mobile Number </label>

            <div class="checkbox-wrapper">
              <label class="checkbox-item">
                <input
                  class="input-checkbox"
                  type="checkbox"
                  formControlName="hasMobile"
                  (change)="onMobileOptionChange('hasMobile')"
                />
                Number available
              </label>

              <label class="checkbox-item">
                <input
                  class="input-checkbox"
                  type="checkbox"
                  formControlName="noMobile"
                  (change)="onMobileOptionChange('noMobile')"
                />
                Number not available
              </label>
            </div>
          </div>

          <div
            class="form-group mb-3"
            *ngIf="dependentForm.get('hasMobile')?.value"
          >
            <label>Enter Member's mobile number</label>
            <ngx-intl-tel-input
              class="custom_imput"
              [inputId]="'phone-input'"
              [cssClass]="'custom'"
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="false"
              [enablePlaceholder]="false"
              [searchCountryFlag]="true"
              [customPlaceholder]="'Enter Phone Number'"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name,
              ]"
              (input)="validateLoginNumber($event)"
              (keydown)="blockNonNumeric($event)"
              [selectFirstCountry]="true"
              [selectedCountryISO]="CountryISO.Zimbabwe"
              [separateDialCode]="true"
              [maxLength]="10"
              [phoneValidation]="false"
              name="phone"
              formControlName="phone"
              [ngClass]="{
                'error-border':
                  dependentForm.get('phone')?.errors?.invalidZimbabweMobile &&
                  dependentForm.get('phone')?.touched,
                'normal-border': !(
                  !dependentForm.get('phone')?.errors?.required &&
                  dependentForm.get('phone')?.touched
                ),
              }"
            >
            </ngx-intl-tel-input>
            <div
              *ngIf="dependentForm.get('phone')?.touched"
              class="text-danger mt-1"
            >
              <div
                *ngIf="dependentForm.get('phone')?.errors?.required"
                class="text-danger"
              >
                Phone Number is required.
              </div>
              <div
                class="text-danger"
                *ngIf="
                  !dependentForm.get('phone')?.errors?.required &&
                  dependentForm.get('phone')?.errors?.invalidZimbabweMobile
                "
              >
                Invalid Zimbabwe phone number.
              </div>
            </div>
          </div>
          <span class="otp-info" *ngIf="dependentForm.get('hasMobile')?.value">
            To add this member, an OTP will be sent to this number. The member
            can be added only after entering the OTP on the next screen.
          </span>
          <div
            class="caregiver-alert"
            *ngIf="dependentForm.get('noMobile')?.value"
          >
            <div class="alert-icon">
              <div class="alert-icon-circle"><span class="i-icon">i</span></div>
            </div>

            <div class="alert-content">
              <h5>You will be assigned his/her caregiver</h5>
              <p>
                This member has no phone number, so you’ll be the default
                caregiver.
              </p>
              <p>
                Doctor calls will come to your phone. You can change this
                anytime.
              </p>
            </div>
          </div>
        </div>
        <div class="form-group custom-center">
          <button
            type="submit"
            class="add-new-btn button_class"
            *ngIf="dependentForm.get('hasMobile')?.value"
          >
            Continue
          </button>
          <button
            type="submit"
            class="add-new-btn button_class"
            *ngIf="dependentForm.get('noMobile')?.value"
          >
            Add Now
          </button>
          <button
            type="button"
            id="modalAutoClose"
            class="d-none"
            data-bs-dismiss="modal"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /Add Dependent Modal-->

<!-- Enter otp screen-->
<div
  #otpModalRef
  class="modal fade assign-caregiver-modal"
  id="otp_modal"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content otp-modal">
      <div class="login-back">
        <a (click)="goBack()">
          <i class="fa-solid fa-arrow-left-long"></i> Back</a
        >
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="login-title">
        <h4 class="otp-heading">Enter OTP</h4>
        <p class="mb-0 otp-text" *ngIf="otpModalType == 'ADD_MEMBER'">
          Enter 6-digit OTP sent to {{ maskedPhone }} to add this number.
        </p>
        <p class="mb-0 otp-text" *ngIf="otpModalType == 'ASSIGN_CAREGIVER'">
          Enter 6-digit OTP sents to {{ caregiverPayload?.first_name }}
          {{ caregiverPayload?.last_name }} number
          {{ caregiverPayload?.country_dial_code }} -
          {{ caregiverPayload?.phone_number }}
          to confirm becoming
          {{ becomeCaregiver?.first_name }}
          {{ becomeCaregiver?.last_name }} caregiver.
        </p>
      </div>
      <form
        method="get"
        class="digit-group login-form-control"
        autocomplete="off"
      >
        <div class="otp-box forms-block otp-container">
          <div class="otp-inputs">
            <ng-container *ngFor="let num of [1, 2, 3, 4, 5, 6]">
              <input
                [(ngModel)]="oneTimePassword['data' + num]"
                maxlength="1"
                type="text"
                id="digit-{{ num }}"
                name="digit-{{ num }}"
                [attr.data-next]="'digit-' + (num + 1)"
                [attr.data-previous]="'digit-' + (num - 1)"
                autocomplete="off"
                (keydown)="allowOnlyNumbers($event)"
                (blur)="markOtpTouched(num)"
                (keydown.backspace)="
                  tiggerBackspace(oneTimePassword['data' + num], 'digit-' + num)
                "
                (input)="onOtpInput($event, num); validateOtp()"
                (paste)="handlePaste($event)"
                [ngClass]="{
                  'error-border':
                    (!oneTimePassword['data' + num] && isSubmitted) ||
                    errorMessage,
                }"
              />
            </ng-container>
          </div>
          <div *ngIf="isSubmitted || errorMessage" class="error-text-message">
            {{ errorMessage }}
          </div>
        </div>
        <div class="forms-block resend-otp">
          <div class="otp-code">
            <a
              href="javascript:void(0);"
              [class.disabled]="countdown > 0"
              [style.pointerEvents]="countdown > 0 ? 'none' : 'auto'"
              [ngClass]="countdown <= 0 ? 'resend-active' : ''"
              (click)="countdown === 0 && resendOtpForDependent()"
              >Resend Code</a
            >
          </div>
          <div class="otp-sec">
            <p>
              <i class="feather icon-clock"></i>
              <span>{{ countdown }}</span> secs
            </p>
          </div>
        </div>
        <div class="reset-btn">
          <button
            class="btn button_class"
            type="button"
            (click)="verifyOtpForDependent()"
          >
            {{
              otpModalType === "ASSIGN_CAREGIVER" ? "Continue" : "Add Member"
            }}
          </button>
          <button
            type="button"
            id="otp_modal_close"
            class="d-none"
            data-bs-dismiss="modal"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Enter otp screen-->

<!-- Successfull memeber add-->
<div
  class="modal fade register-modal"
  id="add_success_member_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content success-modal">
      <button
        type="button"
        class="btn-close custom-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>

      <div class="modal-body">
        <div class="success-icon">
          <i class="fa-solid fa-check check-icon"></i>
        </div>

        <h4 class="success-title">
          New Member Added <br />
          <strong>Successfully!!</strong>
        </h4>

        <div class="member-details">
          <p>Member Name</p>
          <h5>
            {{ dependentDetails?.first_name }} {{ dependentDetails?.last_name }}
          </h5>

          <p class="mt-3">Patient ID</p>
          <h5>MA{{ dependentDetails?.user_id }}</h5>
        </div>

        <div class="success-buttons">
          <button
            class="add-new-btn button_class"
            (click)="manageMember('add-member')"
          >
            Manage Member
          </button>

          <button class="add-new-btn button_class">Get Subscription</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Successfull memeber add -->

<!-- Number already register-->
<div
  class="modal fade register-modal"
  id="already_member_register_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content success-modal">
      <button
        type="button"
        class="btn-close custom-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>

      <div class="modal-body">
        <div class="success-icon warning-icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>

        <div class="member-details">{{ numberExist }}</div>

        <h4 class="success-title">
          This number is <br />
          <strong>Already Registered</strong>
        </h4>

        <div class="member-details">
          <p>Don’t upset, you can still add this member.</p>
        </div>

        <div class="success-buttons">
          <button class="add-new-btn button_class" (click)="existingPopup()">
            Add Existing Member
          </button>

          <button class="add-new-btn button_class" (click)="editNumber()">
            Edit Number
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Number already register -->

<!-- Add Existing Member-->
<div
  class="modal fade register-modal"
  id="add_existing_member_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content existing-member-modal">
      <form
        [formGroup]="existingMemberForm"
        (ngSubmit)="onExistingMemberSubmit()"
      >
        <div class="modal-header border-0">
          <h5 class="modal-title">Add Existing Member</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="closePopup('existing')"
          ></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label fw-semibold">Search Member</label>
            <small class="text-muted d-block mb-2">
              We'll send an OTP to the mobile number linked with the patient ID
            </small>

            <div class="search-boxes">
              <div class="input-wrapper">
                <input
                  type="text"
                  class="form-control"
                  placeholder="SEARCH BY PATIENT ID e.g - MA8977242"
                  formControlName="patientId"
                />
                <i class="fa fa-search search-icon"></i>
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="
                  existingMemberForm.get('patientId')?.touched &&
                  existingMemberForm.get('patientId')?.errors?.invalidPrefix
                "
              >
                Patient ID must start with uppercase MA only.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="
                  existingMemberForm.get('patientId')?.touched &&
                  existingMemberForm.get('patientId')?.errors?.required
                "
              >
                Patient ID is required.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="
                  existingMemberForm.get('patientId')?.touched &&
                  existingMemberForm.get('patientId')?.errors?.invalidFormat
                "
              >
                Only numbers are allowed after MA.
              </div>
            </div>

            <div class="search-result mt-2" *ngIf="users && users.length > 0">
              <div
                class="search-item p-2 border rounded mb-1 cursor-pointer"
                *ngFor="let user of users"
                (click)="selectUser(user)"
              >
                <div>
                  <strong>{{ maskPhone(user.phone) }}</strong>
                </div>

                <small>
                  {{ maskName(user.first_name) }}
                  {{ maskName(user.last_name) }}
                </small>
              </div>
            </div>

            <div
              class="text-danger mt-2"
              *ngIf="isSearched && !selecteduser && users.length === 0"
            >
              No user found
            </div>
          </div>

          <div class="mb-3">
            <label class="control-label mb-10">
              Date of Birth <span class="text-danger">*</span>
            </label>

            <div class="position-relative">
              <input
                #dp="bsDatepicker"
                type="text"
                class="form-control"
                bsDatepicker
                placement="top"
                placeholder="Select Date of Birth"
                formControlName="dob"
                (bsValueChange)="handleDateOfBirthSelection($event)"
                [bsConfig]="dobsDatepickerConfig"
                [outsideClick]="true"
                inputmode="none"
                readonly
                onkeydown="return false;"
                autocomplete="new-dob"
              />

              <i
                class="fa-regular fa-calendar position-absolute"
                (click)="dp.toggle()"
              ></i>
            </div>

            <div *ngIf="existingMemberForm.get('dob')?.touched">
              <div
                class="text-danger mt-1"
                *ngIf="existingMemberForm.get('dob')?.errors?.required"
              >
                Date of Birth is required.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="existingMemberForm.errors?.futureDate"
              >
                Date of Birth cannot be in the future.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="existingMemberForm.errors?.ageExceeded"
              >
                Age cannot be more than 65.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="existingMemberForm.errors?.under18NotAllowed"
              >
                Member must be 18+ to add a mobile number.
              </div>

              <div
                class="text-danger mt-1"
                *ngIf="existingMemberForm.errors?.zeroAgeNotAllowed"
              >
                Age must be greater than 0.
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="control-label mb-2">
              Relationship <span class="text-danger">*</span>
            </label>

            <select class="form-select" formControlName="relation">
              <option value="" disabled>Select Relationship</option>
              <option value="Spouse">Spouse</option>
              <option value="Biological children">Biological children</option>
              <option value="Sibling">Sibling</option>
              <option value="Biological parent">Biological parent</option>
              <option value="Grandparent">Grandparent</option>
              <option value="In laws">In laws</option>
            </select>

            <div
              class="text-danger mt-1"
              *ngIf="
                existingMemberForm.get('relation')?.touched &&
                existingMemberForm.get('relation')?.invalid
              "
            >
              Relationship is required.
            </div>
          </div>

          <div class="text-start">
            <button
              type="submit"
              class="add-new-btn button_class"
              [disabled]="
                !selecteduser ||
                !existingMemberForm.get('relation')?.value ||
                existingMemberForm.invalid
              "
            >
              Send OTP
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Add Existing Member -->

<!-- Successfull Caregiver add-->
<div
  class="modal fade register-modal"
  id="add_success_caregiver_member_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content success-modal">
      <button
        type="button"
        class="btn-close custom-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>

      <div class="modal-body">
        <div class="success-icon">
          <i class="fa-solid fa-check check-icon"></i>
        </div>

        <h4 class="success-title">
          Caregiver Added <br />
          <strong>Successfully!!</strong>
        </h4>

        <div class="member-details">
          <p>Patinet Name</p>
          <h5>
            {{ successCaregiverData?.first_name }}
            {{ successCaregiverData?.last_name }}
          </h5>

          <p class="mt-3">Caregiver</p>
          <h5>
            {{ successCaregiverData?.caregiverInfo?.first_name }}
            {{ successCaregiverData?.caregiverInfo?.last_name }}
          </h5>

          <p class="mt-3">Duration</p>
          <h5>{{ successCaregiverData?.caregiverInfo?.duration_to }}</h5>
        </div>

        <div class="success-buttons">
          <button
            class="add-new-btn button_class"
            (click)="manageMember('caregiver')"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Successfull Caregiver add -->

<!-- Leave Family -->
<div
  class="modal fade"
  id="leave_family_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content success-modal">
      <button
        type="button"
        class="btn-close custom-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>

      <div class="modal-body">
        <div class="success-icon warning-icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>

        <h4 class="success-title">
          Think Again!!<br />
          <strong>Are you sure you want to leave family?</strong>
        </h4>

        <div class="success-buttons">
          <button class="add-new-btn button_class">Yes</button>
          <button class="add-new-btn button_class">No</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Leave Family -->

<!-- Leave Caregiver -->
<div
  class="modal fade"
  id="leave_caregiver_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content success-modal">
      <button
        type="button"
        class="btn-close custom-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>

      <div class="modal-body">
        <div class="success-icon warning-icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>

        <h5 class="success-title">
          You are the caregiver of Siddhi.<br />
          If you leave, the admin will assign a new default caregiver.
        </h5>

        <h4 class="success-title">
          Think Again!!<br />
          <strong>Are you sure you want to leave family?</strong>
        </h4>

        <div class="success-buttons">
          <button class="add-new-btn button_class">Yes</button>
          <button class="add-new-btn button_class">No</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Leave Caregiver -->

<!-- Assign Caregiver -->
<div
  class="modal fade assign-caregiver-modal"
  id="assign_caregiver_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title">Caregiver</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <div class="modal-body">
        <p class="desc">
          A caregiver is a trusted person who assists during a doctor
          consultation with the patient's permission.
        </p>

        <!-- List -->
        <div class="caregiver-benefits">
          <p class="title">What a Caregiver can do on patient behalf :</p>
          <ul class="benefits-list">
            <li>Book appointment</li>
            <li>Chat/video call with contact on caregiver number</li>
            <li>Change/edit appointments</li>
            <li>View profile</li>
            <li>Can do Payment via Ala Carte</li>
            <li>View medical records (If giving Access)</li>
            <li>Upload reports</li>
            <li>Get notifications</li>
          </ul>
        </div>

        <div class="mb-3 caregiver-dropdown">
          <label class="control-label mb-2">
            Select Caregiver for {{ selectedPatientName }}
          </label>

          <small class="conf">
            An otp will sent to caregiver number for confirmation
          </small>

          <div class="custom-dropdown">
            <!-- Selected Value -->
            <div class="selected-card" (click)="toggleDropdown()">
              <ng-container *ngIf="selectedCaregiver; else placeholder">
                <div class="card-left">
                  <h4>
                    {{ selectedCaregiver.first_name }}
                    {{ selectedCaregiver.last_name }}
                  </h4>

                  <p>
                    {{ selectedCaregiver.country_dial_code }}
                    - {{ selectedCaregiver.phone }}
                  </p>
                </div>

                <span class="meta">
                  {{
                    selectedCaregiver?.dob
                      ? getAge(selectedCaregiver?.dob)
                      : "-"
                  }}/
                  {{
                    selectedCaregiver?.gender === "Male"
                      ? "M"
                      : selectedCaregiver?.gender === "Female"
                        ? "F"
                        : "-"
                  }}
                </span>
              </ng-container>

              <ng-template #placeholder>
                <span class="placeholders">Select Caregiver</span>
              </ng-template>

              <span class="arrow" [class.open]="isDropdownOpen">
                <svg width="19" height="19" viewBox="0 0 20 20">
                  <path
                    d="M5 7l5 5 5-5"
                    fill="none"
                    stroke="#555"
                    stroke-width="2"
                  />
                </svg>
              </span>
            </div>

            <!-- Dropdown List -->
            <div class="dropdown-list" *ngIf="isDropdownOpen">
              <div
                class="caregiver-card"
                *ngFor="let caregiver of caregiverList"
                (click)="selectCaregiver(caregiver)"
                [class.active]="selectedCaregiver?.id === caregiver.id"
              >
                <div class="card-left">
                  <h4>{{ caregiver.first_name }} {{ caregiver.last_name }}</h4>

                  <p>
                    {{ caregiver.country_dial_code }} - {{ caregiver.phone }}
                  </p>
                </div>

                <span class="meta">
                  ({{ getAge(caregiver.dob) }}/{{
                    caregiver.gender | slice: 0 : 1
                  }})
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <label class="control-label mb-2">Duration</label>

          <select
            class="form-select"
            [(ngModel)]="selectedDuration"
            (change)="onDurationChange()"
            name="duration"
          >
            <option value="" disabled>Select Duration</option>
            <option value="ONE_TIME">One time only</option>
            <option value="ONE_DAY">One day</option>
            <option value="SEVEN_DAYS">Seven days</option>
            <option value="ONE_MONTH">One month</option>
            <option value="UNTIL_REMOVE">Until I remove</option>
            <option value="CUSTOM_DATE">Custom Date</option>
          </select>
        </div>

        <div class="mb-3" *ngIf="selectedDuration == 'CUSTOM_DATE'">
          <div class="row g-2">
            <!-- Start Date -->
            <div class="col-md-6">
              <label class="form-label">Start Date</label>
              <input
                type="date"
                class="form-control"
                [(ngModel)]="customStartDate"
                (change)="onStartDateChange()"
                name="startDate"
                [min]="todayDate"
              />
            </div>

            <!-- End Date -->
            <div class="col-md-6">
              <label class="form-label">End Date</label>
              <input
                type="date"
                class="form-control"
                [(ngModel)]="customEndDate"
                name="endDate"
                [min]="customStartDate || todayDate"
              />
            </div>
          </div>

          <!-- Validation -->
          <small class="text-danger" *ngIf="dateError">
            End date must be greater than start date
          </small>
        </div>

        <div class="text-start">
          <button
            type="submit"
            class="add-new-btn button_class"
            (click)="continueAssign()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Assign Caregiver -->

<!-- Welcome Modal for dependent -->
<div
  class="modal fade"
  id="welcome_caregiver_modal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content p-4">
      <h4 class="fw-bold">Welcome, Atul!</h4>
      <p class="text-muted small">
        Your profile has already been created by your family member Yogesh.
        Please claim your profile to get access.
      </p>

      <h6 class="fw-semibold">Choose an Option</h6>
      <p class="text-muted small">
        You will decide how your profile and family support work
      </p>

      <div class="option-card active-option p-3 rounded">
        <div class="row align-items-center">
          <div class="col-md-3">
            <img src="assets/family-color.jpg" class="img-fluid rounded" />
          </div>

          <div class="col-md-6">
            <h6 class="text-primary fw-bold">Stay connected with family</h6>
            <p class="small text-muted">
              You and your family members can support each other by:
            </p>

            <ul class="benefits-points">
              <li>Booking appointments when needed</li>
              <li>Consulting doctors on each other's behalf</li>
              <li>Helping during urgent medical situations</li>
            </ul>
          </div>

          <div class="col-md-3 text-end">
            <button class="btn btn-info text-white px-4">Continue</button>
          </div>
        </div>
      </div>

      <div class="option-card p-3 rounded">
        <div class="row align-items-center">
          <div class="col-md-3">
            <img
              src="assets/family-grey.jpg"
              class="img-fluid rounded grayscale"
            />
          </div>

          <div class="col-md-6">
            <h6 class="text-danger fw-bold">Leave Family</h6>
            <p class="small text-muted">
              You will be separated from Yogesh's family. They will not be able
              to:
            </p>

            <ul class="benefits-points">
              <li>Access your profile</li>
              <li>Book appointments for you</li>
              <li>Help during medical emergencies</li>
            </ul>
          </div>

          <div class="col-md-3 text-end">
            <button class="btn btn-info text-white px-4">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Welcome Modal for dependent -->

<!-- Profile setting -->
<div
  id="view_profile_modal"
  class="modal fade custom-modal"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
>
  <div class="modal-dialog modal-dialog-centered modal-profile-content">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closePopup('profile')"
        ></button>
      </div>
      <div class="modal-body">
        <app-profile-settings [isOpenFromPopup]="true"></app-profile-settings>
      </div>
    </div>
  </div>
</div>
<!-- Profile setting -->

<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="skyblue"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p class="spinner-text">Please wait...</p>
</ngx-spinner>
